"use client";

import { c as _c } from "react/compiler-runtime";
import MediaDisplay from "@/components/drops/view/item/content/media/MediaDisplay";
import { ImageScale } from "@/helpers/image.helpers";
import { getDropPreviewImageUrl, type ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { useMemo } from "react";
interface SubmissionArtworkCardProps {
  readonly drop: ExtendedDrop;
  readonly isActive?: boolean;
}
export default function SubmissionArtworkCard(t0) {
  const $ = _c(12);
  const {
    drop,
    isActive: t1
  } = t0;
  const isActive = t1 === undefined ? true : t1;
  const media = drop.parts[0]?.media[0];
  const isTabletOrSmaller = useMediaQuery("(max-width: 1023px)");
  const mediaImageScale = isTabletOrSmaller ? ImageScale.AUTOx450 : ImageScale.AUTOx600;
  let t2;
  if ($[0] !== drop.metadata) {
    t2 = getDropPreviewImageUrl(drop.metadata);
    $[0] = drop.metadata;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const previewImageUrl = t2;
  if (!media) {
    return null;
  }
  const mediaWrapperClasses = `tw-h-full tw-w-full ${isActive ? "tw-shadow-[0_8px_32px_rgba(255,255,255,0.08)]" : "tw-pointer-events-none"}`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-z-10 tw-mt-2 tw-rounded-lg tw-shadow-[inset_0_0_20px_rgba(0,0,0,0.3)] tw-ring-1 tw-ring-inset tw-ring-white/[0.15]" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = isActive ? _temp : undefined;
  const t5 = drop.parts[0]?.media[0].mime_type ?? "image/jpeg";
  const t6 = drop.parts[0]?.media[0].url;
  let t7;
  if ($[3] !== mediaImageScale || $[4] !== previewImageUrl || $[5] !== t5 || $[6] !== t6) {
    t7 = <MediaDisplay media_mime_type={t5} media_url={t6} disableMediaInteraction={true} imageScale={mediaImageScale} previewImageUrl={previewImageUrl} />;
    $[3] = mediaImageScale;
    $[4] = previewImageUrl;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== mediaWrapperClasses || $[9] !== t4 || $[10] !== t7) {
    t8 = <div className="tw-h-full tw-w-full tw-overflow-hidden tw-bg-black">{t3}<div className={mediaWrapperClasses} onClick={t4}>{t7}</div></div>;
    $[8] = mediaWrapperClasses;
    $[9] = t4;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}
function _temp(event) {
  return event.stopPropagation();
}